import isEmpty from 'lodash/isEmpty';
import filter from 'lodash/filter';
import get from 'lodash/get';
import { getScreenData, Store } from 'cw-ui-core';
import { toArray } from 'src/util/Util';

const DUO_CLAIMS = {
    DUO_USER_NAME: 'duo_user_name',
    DUO_MFA_ID: 'duo_mfa_id',
    DUO_ENABLED: 'duo_mfa',
};

function findDuoClaim(userClaims, claimType) {
    const claim = userClaims?.find(clm => clm.claimType === claimType);
    return claim?.claimValue?.value ?? claim?.claimValue ?? '';
}
export function duoMfaDetails(userAdditionalClaims) {
    const duoUserName = findDuoClaim(userAdditionalClaims, DUO_CLAIMS.DUO_USER_NAME);
    const duoMfaId = findDuoClaim(userAdditionalClaims, DUO_CLAIMS.DUO_MFA_ID);
    const duoEnabled = findDuoClaim(userAdditionalClaims, DUO_CLAIMS.DUO_ENABLED);
    return {
        duoUserName,
        provider: { id: duoMfaId },
        duoEnabled,
    };
}

export function createDuoAdditionalClaims(additionalClaims, screenKey) {
    const duoDetails = toArray(getScreenData(Store().getState().screen, ['duoMfaDetails'], screenKey));
    if (!isEmpty(duoDetails)) {
        const userNameclaim = {
            claimType: DUO_CLAIMS.DUO_USER_NAME,
            claimValue: duoDetails.duoUserName,
        };
        additionalClaims.push(userNameclaim);

        const mfaIdClaim = {
            claimType: DUO_CLAIMS.DUO_MFA_ID,
            claimValue: duoDetails.provider.id,
        };

        additionalClaims.push(mfaIdClaim);
    }
    return additionalClaims;
}

export function updateDuoClaims(userDetails, duoMfaUpdates) {
    const { additionalClaims } = userDetails;
    const duoMfa = filter(additionalClaims, x => x.claimType === DUO_CLAIMS.DUO_ENABLED);
    const duoUpdates = [];
    const position = '-';
    if (isEmpty(duoMfa)) {
        const userNameclaim = {
            claimType: DUO_CLAIMS.DUO_USER_NAME,
            claimValue: duoMfaUpdates?.duoUserName,
        };
        duoUpdates.push([position, userNameclaim]);
        const mfaIdClaim = {
            claimType: DUO_CLAIMS.DUO_MFA_ID,
            claimValue: duoMfaUpdates?.provider?.id,
        };
        duoUpdates.push([position, mfaIdClaim]);
        return duoUpdates;
    }
    const userNameIndex = additionalClaims.findIndex(e => e.claimType === DUO_CLAIMS.DUO_USER_NAME);
    const mfaIdIndex = additionalClaims.findIndex(e => e.claimType === DUO_CLAIMS.DUO_MFA_ID);
    if (duoMfaUpdates?.duoUserName) {
        const userNameclaim = {
            claimType: DUO_CLAIMS.DUO_USER_NAME,
            claimValue: duoMfaUpdates?.duoUserName,
        };
        duoUpdates.push([userNameIndex.toString(), userNameclaim]);
    }
    if (duoMfaUpdates?.provider?.id) {
        const mfaIdClaim = {
            claimType: DUO_CLAIMS.DUO_MFA_ID,
            claimValue: duoMfaUpdates?.provider?.id,
        };
        duoUpdates.push([mfaIdIndex.toString(), mfaIdClaim]);
    }
    return duoUpdates;
}

export function duoClaimsToRemove(userDetails) {
    const { additionalClaims } = userDetails;
    const patches = [];
    const duoMfa = filter(additionalClaims, x => x.claimType === DUO_CLAIMS.DUO_ENABLED);
    if (get(duoMfa[0], 'claimValue', '') === 'enabled') {
        const userNameIndex = additionalClaims.findIndex(e => e.claimType === DUO_CLAIMS.DUO_USER_NAME);
        const mfaIdIndex = additionalClaims.findIndex(e => e.claimType === DUO_CLAIMS.DUO_MFA_ID);
        const duoMfaIndex = additionalClaims.findIndex(e => e.claimType === DUO_CLAIMS.DUO_ENABLED);
        if (userNameIndex >= 0) {
            patches.push({
                path: `additionalClaims/${userNameIndex}`,
                op: 'remove',
            });
        }
        if (mfaIdIndex >= 0) {
            patches.push({
                path: `additionalClaims/${mfaIdIndex}`,
                op: 'remove',
            });
        }
        if (duoMfaIndex >= 0) {
            patches.push({
                path: `additionalClaims/${duoMfaIndex}`,
                op: 'remove',
            });
        }
    }
    return patches;
}
